import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCreateGroup } from "../../../api/hooks";
import Modal from "../../_shared/Modal/Modal";
import Input from "../../_shared/Input/Input";
import Button from "../../_shared/Button/Button";
import styles from "./Modal.module.css";

const CreateSubgroupModal = ({ isOpen, onClose, parentGroup, organizationId, onSuccess }) => {
  const { t } = useTranslation("common");
  const [groupName, setGroupName] = useState("");
  const [error, setError] = useState(null);

  const createGroupMutation = useCreateGroup();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!groupName.trim()) return;

    setError(null);

    try {
      await createGroupMutation.mutateAsync({
        name: groupName.trim(),
        type: "group",
        parentGroupId: parentGroup?.id || organizationId
      });
      setGroupName("");
      onSuccess?.();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create group");
    }
  };

  const handleClose = () => {
    if (!createGroupMutation.isLoading) {
      setGroupName("");
      setError(null);
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t("auth.settings.organizations.createNewGroup")}
    >
      {parentGroup && (
        <p className={styles.subtitle}>
          {t("auth.settings.organizations.under")}: {parentGroup.name}
        </p>
      )}

      {error && <div className={styles.error}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <Input
          label={t("auth.settings.organizations.groupName")}
          type="text"
          value={groupName}
          onChange={setGroupName}
          placeholder={t("auth.settings.organizations.groupName")}
          disabled={createGroupMutation.isLoading}
          required
        />
        <div className={styles.actions}>
          <Button
            type="submit"
            variant="primary"
            disabled={createGroupMutation.isLoading || !groupName.trim()}
          >
            {createGroupMutation.isLoading
              ? t("auth.settings.organizations.creating")
              : t("auth.settings.organizations.create")}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={handleClose}
            disabled={createGroupMutation.isLoading}
          >
            {t("cancel")}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateSubgroupModal;
